import { Property, PropertyBusinessType } from 'models/Properties';
import { getFullAddress } from 'utils/property/propertyUtils';
import { PropertyForPropertyListItem } from 'pages/agencyProperties/Properties.types';
import PropertyGuestsBedroomsAndBathroomsCount from 'pages/agencyProperties/item/PropertyGuestsBedroomsAndBathroomsCount';
import {
  PropertyAddressStyled,
  PropertyCharacteristicsStyled,
  PropertyInfoStyled,
  PropertyNameWrapperStyled,
} from 'pages/agencyProperties/item/PropertyListItem.styles';
import PropertyLabel from 'components/domain/property/label/PropertyLabel';
import usePropertyEditPath from 'pages/property/usePropertyEditPath';
import { PropertyNameStyled } from './propertyListItem/PropertyListItem.styles';

interface PropertyInfoProps {
  property: PropertyForPropertyListItem;
}

const PropertyInfo = ({ property }: PropertyInfoProps) => {
  const isUnitType = property.businessType === PropertyBusinessType.UNIT_TYPE;
  const isHotel = property.businessType === PropertyBusinessType.HOTEL;

  const getPropertyEditPath = usePropertyEditPath();
  const propertyUrl = getPropertyEditPath(property as Property);

  return (
    <PropertyInfoStyled>
      <PropertyNameWrapperStyled>
        <PropertyNameStyled href={propertyUrl} target="_blank" rel="noreferrer">
          {property.name}
        </PropertyNameStyled>

        <PropertyLabel property={property} />
      </PropertyNameWrapperStyled>
      {'address' in property && !isUnitType && (
        <PropertyAddressStyled>
          {getFullAddress(property)}
        </PropertyAddressStyled>
      )}
      <PropertyCharacteristicsStyled data-testid="property-list-item-characteristics">
        {!isHotel && (
          <PropertyGuestsBedroomsAndBathroomsCount property={property} />
        )}
      </PropertyCharacteristicsStyled>
    </PropertyInfoStyled>
  );
};

export default PropertyInfo;
